import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteAssignmentOperation = async (
  assignmentId: number,
  setAssignmentId: (assignmentId: number | null) => any,
) => {
  try {
    setAssignmentId(assignmentId);

    const res = await appApi.deleteAssignmentType(assignmentId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    }
    setAssignmentId(null);
  } catch (e) {
    setAssignmentId(null);
    console.error(
      `deleteAssignmentOperation is failed with the assignmentId: ${assignmentId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
